import React, { useCallback, useState, useEffect } from 'react';
import { View, Image, StyleSheet } from 'react-native';

// @ts-ignore
import poapImage from '../assets/mcon-poap.png';
import ConnectWallet from '../ConnectWallet';
import { useWallet } from '../WalletProvider';
import AnimatedPointingButton from '../views/AnimatedPointingButton';
import { httpsCallable, snapshot } from '../firebase';
import Typography from '../views/Typography';

export default function ClaimToken() {
  const { wallet, address } = useWallet();
  const [claiming, setClaiming] = useState(false);
  const [amountLeft, setAmountLeft] = useState(100);

  useEffect(() => {
    return snapshot('codes', 'metadata', doc => {
      const data = doc.data() as { amountLeft: number };
      setAmountLeft(data.amountLeft);
    });
  }, []);

  const onClaim = useCallback(async () => {
    try {
      setClaiming(true);
      const result = await httpsCallable('claimToken')({ address });

      if (result.data) {
        // @ts-ignore
        window.location = `http://POAP.xyz/claim/${result.data}?address=${address}`;
      }
    } finally {
      setClaiming(false);
    }
  }, [address]);

  return (
    <View style={styles.container}>
      <Image style={styles.image} source={poapImage} />
      <Typography>{amountLeft} tokens left</Typography>
      { amountLeft > 0 && (
        <>
          { !wallet ? <ConnectWallet /> : (
            <AnimatedPointingButton
              title="Claim POAP"
              onPress={onClaim}
              loading={claiming}
            />
          )}
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  image: {
    marginTop: 50,
    marginBottom: 20,
    width: 250,
    height: 250,
  },
});
